export default __webpack_public_path__ + "static/media/BONDLY-BNB.528dc53d.svg";